export default {
  de: {
    title: 'Neue Bundespräsidenten hinzufügen',
    name: 'Name',
    submit: 'Bundespräsidenten erstellen',
    back: 'Zurück',
    alerts: {
      500: () => 'Ein unbekannter Fehler ist aufgetretten! Bitte versuchen Sie es in kürze erneut!',
    },
  },
};
